/* global Metafans_JS */
import { resetActivityForm } from './activity-form.js';
import { get as stateGet, set as stateSet } from './state.js';
import { sharingSpinner } from './templates.js';
import { toggleActivityPostFormPopup } from './ui.js';

/**
 * Handles the submission of the "What's New" activity form.
 * @param {Event} e - The form submission event.
 */
async function handleFormSubmit(e) {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);
    const formObject = Object.fromEntries(formData.entries());

    // Clean up content input (remove div/br artifacts from contenteditable)
    const contentEl = document.getElementById('th-bp-whats-new');
    let contentHtml = contentEl ? contentEl.innerHTML : '';
    contentHtml = contentHtml.replace(/<div>/g, "\n").replace(/<\/div>/g, "").replace(/<br>/g, "\n");
    contentHtml = contentHtml.replace(/(\r?\n){2,}/g, "\n");

    const urlPreviewEl = document.getElementById('whats-new-post-url-preview');
    const accessibilityEl = document.getElementById('mf-activity-accessibility');

    // Build Data Object
    const newData = {
        ...formObject,
        'whats-new-post-content': contentHtml,
        'whats-new-post-url-preview': urlPreviewEl ? urlPreviewEl.value : '',
        activity_accessibility: accessibilityEl ? accessibilityEl.value : 'public',
        is_delete_activity: stateGet('mf_activity_edite_is_delete_activity'),
        activity_id: stateGet('mf_activity_id_of_current_editeing_activity'),
    };

    // Prepare Payload
    const payload = new URLSearchParams();
    payload.append('action', 'th_bp_post_update');
    payload.append('nonce', newData._wpnonce_post_update);

    for (const key in newData) {
        payload.append(`data[${key}]`, newData[key]);
    }

    // Show loader
    form.classList.add('submitting');
    let spinner = form.querySelector('.sharing-spinner');
    if (!spinner) {
        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = sharingSpinner;
        spinner = tempContainer.firstElementChild;
        form.appendChild(spinner);
    }

    try {
        const res = await fetch(Metafans_JS.ajaxurl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: payload.toString(),
        }).then(response => {
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.json();
        });

        if (res.success) {
            // FIX: Robust selector for the Activity List (supports standard BP and Theme layouts)
            const activityList = document.querySelector('#activity-stream ul.activity-list')
                || document.querySelector('ul.activity-list')
                || document.querySelector('#activity-stream');

            if (activityList) {
                // FIX: Use 'firstElementChild' to ignore whitespace text nodes (which caused the invisible bug)
                const doc = new DOMParser().parseFromString(res.activity, 'text/html');
                const newActivity = doc.body.firstElementChild;

                if (newActivity) {
                    // Prepend to list (showing new post at top)
                    // If the container is just the wrapper div (no ul yet), append the item directly or wrap it?
                    // Usually BP has the UL. If not, prepending to the list is correct.
                    if (activityList.tagName === 'UL' || activityList.tagName === 'OL') {
                        activityList.prepend(newActivity);
                    } else {
                        // Fallback: If list is the wrapper div, check for inner UL or create one
                        let ul = activityList.querySelector('ul');
                        if (!ul) {
                            ul = document.createElement('ul');
                            ul.className = 'activity-list bp-list';
                            activityList.prepend(ul);
                        }
                        ul.prepend(newActivity);
                    }

                    // Animate In (Fade effect)
                    newActivity.style.opacity = '0';
                    newActivity.style.transition = 'opacity 0.5s ease';
                    requestAnimationFrame(() => newActivity.style.opacity = '1');
                }
            } else {
                // Extreme fallback: If no list exists, reload to show post
                window.location.reload();
            }

            // Reset Form & UI
            resetActivityForm();
            const editedActivityDom = stateGet('mf_activity_current_editing_activity_dom');
            if (editedActivityDom) {
                editedActivityDom.remove();
                stateSet('mf_activity_current_editing_activity_dom', false);
                window.scrollTo({ top: 100, behavior: 'smooth' });
            }
            toggleActivityPostFormPopup('close');

        } else if (res.error) {
            alert(res.error);
        }
    } catch (error) {
        console.error('Form submission error:', error);
        alert('An error occurred while posting. Please try again.');
    } finally {
        form.classList.remove('submitting');
        if (spinner) spinner.remove();
    }
}

/**
 * Initializes the activity post form submission handler.
 */
export function init() {
    // Bind to document to handle potential dynamic form reloads
    // Using jQuery delegation here maintains compatibility with legacy BP events if mixed
    if (typeof jQuery !== 'undefined') {
        jQuery(document).on('submit', '#whats-new-form', handleFormSubmit);
    } else {
        // Fallback for vanilla JS only environments
        document.addEventListener('submit', (e) => {
            if (e.target.matches('#whats-new-form')) {
                handleFormSubmit(e);
            }
        });
    }
}